// Mock data for GPS Method™ website

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Professional Actor",
    content: "The GPS Method gave me a framework I didn't know I needed. It's not about quick fixes—it's about understanding the structure beneath performance."
  },
  {
    id: 2,
    name: "James Chen",
    role: "Coach in Training",
    content: "This work demands precision and commitment. The depth of the training has fundamentally changed how I understand presence and psychological readiness."
  },
  {
    id: 3,
    name: "Elena Rodriguez",
    role: "Theatre Director",
    content: "Mel's method is rigorous and clear. It strips away performative thinking and builds something more substantial—a real foundation for the work."
  },
  {
    id: 4,
    name: "David Thompson",
    role: "Executive Coach",
    content: "I came to GPS after years of other methodologies. This is different. It's about internal architecture, not external technique."
  }
];

export const schoolPrograms = [
  {
    id: 1,
    title: "One-Week Intensive Course",
    duration: "1 week",
    description: "Immersive introduction to the GPS Method™ fundamentals. Intensive daily sessions for actors seeking foundational understanding."
  },
  {
    id: 2,
    title: "Two-Month Actor Training",
    duration: "2 months",
    description: "Focused development in psychological presence and internal technique. Structured weekly sessions for working actors."
  },
  {
    id: 3,
    title: "Extended Actor Training",
    duration: "12 months",
    description: "Long-term formation in psychological presence and internal technique for professional actors seeking comprehensive development."
  },
  {
    id: 4,
    title: "Coach Development",
    duration: "18 months",
    description: "Professional training for those teaching the GPS Method™. Small cohorts, rigorous standards, direct guidance."
  },
  {
    id: 5,
    title: "Advanced Labs",
    duration: "Ongoing",
    description: "Continuing formation for established practitioners. Depth work, not refresher courses."
  }
];

export const mockSubmitApplication = async (formData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log('Mock application submitted:', formData);
  return { success: true, message: 'Application received. We will review and contact you within 7 days.' };
};

export const mockSubmitCoachingRequest = async (formData) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log('Mock coaching request submitted:', formData);
  return { success: true, message: 'Request received. We will assess availability and respond within 5 business days.' };
};